import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface LinkDocumento {
  linkDocumentoId: string;
  linkId: number;
  proveedorId: Date;
  documento: Date;
  fechaCreacion: boolean;
  fechaActualizacion: string;
  nombreProveedor: string;
}

@Module
export default class LinkDocumentoModule extends VuexModule {
  errors = {};
  link = {} as LinkDocumento;
  linkDocumentos = [] as Array<LinkDocumento>;

  /**
   * Get current link object
   * @returns LinkDocumento
   */
  get currentLinkDocumento(): LinkDocumento {
    return this.link;
  }

  /**
   * Get errors
   * @returns array
   */
  get getLinkDocumentoErrors() {
    return this.errors;
  }

  @Mutation
  [Mutations.SET_LINK_DOCUMENTO_ERROR](error) {
    this.errors = error;
  }

  @Mutation
  [Mutations.SET_LINK_DOCUMENTO](link) {
    this.link = link;
  }

  @Mutation
  [Mutations.SET_LINK_DOCUMENTOS](links) {
    this.linkDocumentos = links;
  }

  @Action
  [Actions.CREATE_LINK_DOCUMENTO](values) {
    return ApiService.postBlob("/LinkDocumento/v1/linkDocumento", values)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_LINK, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_LINK_ERROR, response.data.errors);
        throw new Error();
      });
  }
  @Action
  [Actions.DESCARGAR_LINK_DOCUMENTO](link) {
    return ApiService.get(`/LinkDocumento/v1/linkDocumento/descargar/${link.linkDocumentoId}`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_LINK, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_LINK_ERROR, response.data.errors);
        throw new Error();
      });
  }

  @Action
  [Actions.GET_LINK_DOCUMENTOS]() {
    return ApiService.get(`LinkDocumento/v1/linkDocumentos`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_LINK_DOCUMENTOS, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_LINK_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.GET_LINK_DOCUMENTO_ID](id) {
    return ApiService.get(`LinkDocumento/v1/linkDocumento/${id}`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_LINK_DOCUMENTO, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_LINK_DOCUMENTO_ERROR, response.data.errors);
      });
  }

  // @Action
  // [Actions.UPDATE_LINK_DOCUMENTOS](params) {
  //   return ApiService.putBlob(`/LinkDocumento/v1/update/linkDocumentos`, params)
  //     .then((data) => {
  //       this.context.commit(Mutations.SET_LINK_DOCUMENTOS, data);
  //       return { exito: true, data: data };
  //     })
  //     .catch(({ response }) => {
  //       this.context.commit(Mutations.SET_LINK_ERROR, response.data.errors);
  //       throw new Error();
  //     });
  // }

  // @Action
  // [Actions.DELETE_LINK_DOCUMENTOS](data) {
  //   return ApiService.post(`/LinkDocumento/v1/linkDocumentos`,data)
  //     .then(({ data }) => {
  //       // this.context.commit(Mutations.SET_USUARIO, data);
  //       return { exito: true, data: data };
  //     })
  //     .catch(({ response }) => {
  //       this.context.commit(Mutations.SET_LINK_ERROR, response.data.errors);
  //     });
  // }
}
